module.exports = __webpack_public_path__ + "img/hot.bbd2ba61.svg";